import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, stopSubmit } from 'redux-form';
import { Form, FormGroup, Label, Alert } from 'reactstrap';

import TextInput from '../../system/fields/TextInput';
import SelectDropdown from '../../system/fields/SelectDropdown';
import FileUpload from '../../system/fields/FileUpload';
import StarRating from '../../system/fields/StarRating';
import Wysiwyg from '../../system/fields/Wysiwyg';

import {
  getBoardTypes,
  getFacilities,
  getRoomTypes,
} from '../../store/overview';
import CreatableSelect from '../../system/fields/CreatableSelect';

import * as Validations from '../../system/utils/Validation';

class EditForm extends React.Component {
  componentDidMount() {
    this.props.dispatch(getBoardTypes());
    this.props.dispatch(getFacilities());
    this.props.dispatch(getRoomTypes());
  }

  render() {
    const { props } = this;
    const { fields } = props;
    const { handleSubmit } = props;
    return (
      <section className='edit-form'>
        <Form onSubmit={handleSubmit}>
          <section className='form-section'>
            <div className='row'>
              <FormGroup className='col-12 col-sm-6'>
                <Label>Hotel Name</Label>
                <Field
                  name='name'
                  component={TextInput}
                  placeholder='Hotel Name'
                  type='text'
                  autoFocus={true}
                />
              </FormGroup>

              <FormGroup className='col-12 col-sm-6'>
                <Label>Hotel Rating</Label>
                <Field
                  name='star_rating'
                  component={StarRating}
                  count={5}
                  type='text'
                />
              </FormGroup>

              <FormGroup className='col-12 col-sm-6'>
                <Label>Trip Advisor id</Label>
                <Field
                  name='trip_advisor_id'
                  component={TextInput}
                  type='text'
                />
              </FormGroup>
            </div>

            <div className='row'>
              <FormGroup className='col-12'>
                <Label>Hotel Summary</Label>
                <Field
                  name='summary'
                  component={Wysiwyg}
                  type='text'
                  className='form-control'
                />
              </FormGroup>

              <FormGroup className='col-12'>
                <Label>Hotel Images</Label>
                <p className='instruction'>
                  Images must be 1920 x 1080 or bigger in the same aspect ratio
                </p>
                <Field
                  name='images'
                  component={FileUpload}
                  multiple={true}
                  files={false}
                  images={true}
                  type='text'
                  className='form-control'
                />
              </FormGroup>
            </div>

            <div className='row'>
              <FormGroup className='col-12 col-sm-6'>
                <Label>Available Room Types</Label>
                <Field
                  name='rooms'
                  component={CreatableSelect}
                  options={props.roomTypes}
                  type='text'
                  labelKey={'name'}
                  valueKey={'id'}
                  multi={true}
                  validate={Validations.required}
                />
              </FormGroup>

              <FormGroup className='col-12 col-sm-6'>
                <Label>Available Board Types</Label>
                <Field
                  name='board_types'
                  component={CreatableSelect}
                  options={props.boardTypes}
                  type='text'
                  labelKey={'name'}
                  valueKey={'id'}
                  multi={true}
                  validate={Validations.required}
                />
              </FormGroup>

              <FormGroup className='col-12 col-sm-6'>
                <Label>Hotel Facilities</Label>
                <Field
                  name='facilities'
                  component={CreatableSelect}
                  options={props.facilities}
                  type='text'
                  valueKey={'id'}
                  labelKey={'name'}
                  multi={true}
                  validate={Validations.required}
                />
              </FormGroup>
            </div>
          </section>
        </Form>

        {props.submitFailed && (
          <div className='error-container'>
            <Alert color='danger'>
              <strong>There are errors in your form.</strong>
              <br />
              Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: 'HotelForm',
})(EditForm);

const mapStateToProps = (state) => {
  return {
    facilities: state.overview.facilities,
    boardTypes: state.overview.boardTypes,
    roomTypes: state.overview.roomTypes,
  };
};

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Hotels/Form.jsx